/*
 * Carrito lateral Salty — inserta los métodos de pago al pie del carrito y,
 * en inglés, el aviso de envío arriba del botón de pagar (carrito lateral y
 * página /cart).
 *
 * El markup lo genera Liquid en <template id="sd-cart-pay"> (ver theme.liquid),
 * con los logos que están cargados en Configuración del tema. Acá solo se
 * clona dentro del pie del drawer. Se hace así, y no agregando un bloque a
 * sections/cart-drawer.liquid, para dejar ese archivo del tema sin tocar.
 */
(function () {
  'use strict';

  function insertar() {
    var tpl = document.getElementById('sd-cart-pay');
    if (!tpl) return;

    var pies = document.querySelectorAll('.hdt-dialog-drawer--cart .hdt-mini-cart__bottom-wrap');
    for (var i = 0; i < pies.length; i++) {
      var pie = pies[i];
      if (pie.querySelector('.sd-pay')) continue;      /* ya está puesto */
      var nodo = tpl.content.cloneNode(true);
      pie.appendChild(nodo);
    }
    insertarAviso();
  }

  /* El template viene vacío si el aviso está apagado o la tienda está en
     español: en ese caso no hay nada que insertar. */
  function insertarAviso() {
    var tpl = document.getElementById('sd-cart-notice');
    if (!tpl || !tpl.content.querySelector('.sd-ship-notice')) return;

    var botones = document.querySelectorAll('.hdt-mini-cart__btn-checkout, .hdt-main-cart__button-checkout');
    for (var i = 0; i < botones.length; i++) {
      var btn = botones[i];
      var padre = btn.parentNode;
      if (!padre || padre.querySelector('.sd-ship-notice')) continue;
      padre.insertBefore(tpl.content.cloneNode(true), btn);
    }
  }

  /* El carrito se re-renderiza al agregar, quitar o cambiar cantidades, así
     que se vuelve a chequear ante cualquier cambio dentro del drawer. */
  function observar() {
    var drawer = document.querySelector('.hdt-dialog-drawer--cart');
    if (!drawer) return false;
    insertar();
    new MutationObserver(function () { insertar(); })
      .observe(drawer, { childList: true, subtree: true });
    return true;
  }

  function init() {
    insertarAviso();                                   /* página /cart */
    if (observar()) return;
    /* El drawer puede entrar al DOM después; se espera a que aparezca. */
    var obs = new MutationObserver(function () {
      if (observar()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Contador del carrito del header: con 0 ítems no se muestra (la insignia
   manteca con un "0" no aporta). El tema solo cambia el número
   (hdt-cart-count); acá se marca data-sd-cero y el CSS lo esconde
   (header-salty-redesign.css). El Liquid ya lo trae marcado al cargar. */
(function () {
  function marcar(el) { el.toggleAttribute('data-sd-cero', el.textContent.trim() === '0'); }
  function init() {
    document.querySelectorAll('hdt-cart-count.hdt-count-box').forEach(function (el) {
      marcar(el);
      new MutationObserver(function () { marcar(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Ancho del buscador lateral = desde el borde izquierdo del logo del header
   hasta el borde derecho de la pantalla (header-salty-redesign.css usa
   --sd-search-w desde 768 px). El logo cambia de ancho con la pantalla, así
   que se mide al cargar y al cambiar el tamaño. */
(function () {
  function medir() {
    var logo = document.querySelector('header .salty-header-logo-img');
    if (!logo) return;
    var r = logo.getBoundingClientRect();
    if (!r.width) return;
    var w = Math.round(document.documentElement.clientWidth - r.left);
    document.documentElement.style.setProperty('--sd-search-w', Math.max(300, w) + 'px');
  }
  var t;
  function luego() { clearTimeout(t); t = setTimeout(medir, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', medir);
  else medir();
  window.addEventListener('load', medir);
  window.addEventListener('resize', luego);
})();


/* Selector de idioma (snippets/salty-lang-switch.liquid): Liquid arma la ruta
   de la misma página en el otro idioma y la guarda en data-sd-href. Acá se le
   suman los parámetros de la URL (?q=, ?page=, ?variant=, que Liquid no ve) y
   se vuelve a poner si el tema la cambia: localeUrl (global.min.js) reescribe
   los links a "/" con la raíz del idioma y el "ES" de la home en inglés
   llevaba a /en/. */
(function () {
  function fijar(a) {
    var base = a.getAttribute('data-sd-href');
    if (!base) return;
    var quiero = base + location.search + location.hash;
    if (a.getAttribute('href') !== quiero) a.setAttribute('href', quiero);
  }
  function init() {
    document.querySelectorAll('a[data-sd-href]').forEach(function (a) {
      fijar(a);
      new MutationObserver(function () { fijar(a); }).observe(a, { attributes: true, attributeFilter: ['href'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* Desplegable de idioma del header en celular (salty-lang-switch, compacto):
   se cierra al tocar fuera de él o con Escape. */
(function () {
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.sd-lang-dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.sd-lang-dd[open]').forEach(function (d) {
      d.removeAttribute('open');
      d.querySelector('summary').focus();
    });
  });
})();


/* Viene de la página /cart, que no se usa (theme.liquid la redirige a la página anterior): abre el carrito lateral
   cuando el tema ya está listo. Se abre con un botón que no está en la página, igual que el ícono del header, para
   no navegar a /cart si el tema todavía no tomó el clic. */
(function () {
  var pendiente = false;
  if (/\/cart\/?$/.test(location.pathname)) return;   /* todavía en /cart, saliendo */
  try {
    pendiente = sessionStorage.getItem('sd-abrir-carrito') === '1';
    sessionStorage.removeItem('sd-abrir-carrito');
  } catch (e) {}
  if (!pendiente || !window.customElements) return;
  customElements.whenDefined('hdt-cart-drawer').then(function () {
    setTimeout(function () {
      var d = document.getElementById('CartDrawer');
      if (!d || d.open) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.hidden = true;
      b.setAttribute('aria-controls', 'CartDrawer');
      document.body.appendChild(b);
      b.click();
      b.remove();
    }, 300);
  });
})();
